var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subscription-form-container"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "textarea-composite-container"
  }, [_c('input-textarea', {
    attrs: {
      "input-id": "bill-description",
      "input-name": _vm.$t('bill.ticket.description.label'),
      "input-title": _vm.$t('bill.ticket.description.label'),
      "input-placeholder": _vm.$t('bill.ticket.description.placeholder'),
      "max-length": 510,
      "required": false,
      "rows": 1,
      "composite": ""
    },
    model: {
      value: _vm.bill.description,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "description", $$v);
      },
      expression: "bill.description"
    }
  }), _c('attachment-image', {
    attrs: {
      "link": _vm.bill.attachment.link,
      "input-id": "bill.attachment",
      "type": "secondary",
      "composite": "",
      "composite-textarea": ""
    },
    on: {
      "loading": _vm.onImageLoading,
      "uploaded": function uploaded(data) {
        return _vm.bill.attachment.setData(data);
      },
      "reset": function reset($event) {
        return _vm.bill.attachment.reset();
      }
    }
  })], 1), _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('allow.multiple.payments')
    },
    model: {
      value: _vm.bill.isMulti,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "isMulti", $$v);
      },
      expression: "bill.isMulti"
    }
  })], 1)])], 1), _vm._l(_vm.bill.billTariffs, function (tariff, idx) {
    return _c('div', {
      key: "tariff-".concat(idx),
      staticClass: "section-container"
    }, [_vm.isDesktop ? [_vm.isSeveralTariffsAvailable ? _c('form-movement-control', {
      attrs: {
        "inactive-up": _vm.isInactiveMovementUp(idx),
        "inactive-down": _vm.isInactiveMovementDown(idx)
      },
      on: {
        "movementUp": function movementUp($event) {
          return _vm.onMovementUp(idx);
        },
        "movementDown": function movementDown($event) {
          return _vm.onMovementDown(idx);
        }
      }
    }) : _vm._e(), _vm.isSeveralTariffsAvailable ? _c('form-delete-icon', {
      on: {
        "click": function click($event) {
          return _vm.onRemoveTariff(idx);
        }
      }
    }) : _vm._e()] : _vm._e(), _c('substrate-mount', [_c('div', {
      staticClass: "input-container"
    }, [_c('input-textarea', {
      attrs: {
        "input-id": "tariff-name-".concat(idx),
        "input-name": _vm.$t('bill.ticket.variant.name.label'),
        "input-title": _vm.$t('bill.ticket.variant.name.label'),
        "input-placeholder": _vm.$t('bill.ticket.variant.name.placeholder'),
        "max-length": 255,
        "required": false,
        "rows": 1
      },
      model: {
        value: tariff.name,
        callback: function callback($$v) {
          _vm.$set(tariff, "name", $$v);
        },
        expression: "tariff.name"
      }
    })], 1), _c('div', {
      staticClass: "input-container"
    }, [_c('input-textarea', {
      attrs: {
        "input-name": _vm.$t('bill.ticket.variant.description.label'),
        "input-title": _vm.$t('bill.ticket.variant.description.label'),
        "input-placeholder": _vm.$t('bill.ticket.variant.description.placeholder'),
        "input-id": "tariff-description-".concat(idx),
        "max-length": 255,
        "required": false,
        "rows": 1
      },
      model: {
        value: tariff.description,
        callback: function callback($$v) {
          _vm.$set(tariff, "description", $$v);
        },
        expression: "tariff.description"
      }
    })], 1), _c('div', {
      staticClass: "textarea-composite-container"
    }, [_c('input-textarea', {
      attrs: {
        "value": tariff.arrangement.template.name,
        "input-id": "tariff-arrangement-template-name-".concat(idx),
        "input-name": _vm.$t('bill.ticket.template.field.label'),
        "input-title": _vm.$t('bill.ticket.template.field.label'),
        "input-placeholder": _vm.$t('bill.ticket.template.field.placeholder'),
        "show-counter": false,
        "max-length": 255,
        "required": false,
        "rows": 1,
        "composite": "",
        "readonly": ""
      },
      on: {
        "click": function click($event) {
          return _vm.handleAttachmentById("attachment-".concat(idx));
        }
      }
    }, [_c('help-link', {
      attrs: {
        "slot": "link",
        "source": "https://help.capusta.space/ticket_template"
      },
      slot: "link"
    })], 1), _c('attachment-image', {
      ref: "attachment-".concat(idx),
      refInFor: true,
      attrs: {
        "link": tariff.arrangement.template.link,
        "input-id": "tariff-arrangement-template-link-".concat(idx),
        "type": "secondary",
        "composite": "",
        "composite-textarea": "",
        "upload-type": "ticket",
        "accept": "application/vnd.ms-word.document.macroEnabled.12, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.ms-word.template.macroEnabled.12"
      },
      on: {
        "loading": _vm.onImageLoading,
        "uploaded": function uploaded(data) {
          return tariff.arrangement.template.setData(data);
        },
        "reset": function reset($event) {
          return tariff.arrangement.template.reset();
        }
      }
    })], 1), _vm.bill.isMulti ? [_c('div', {
      staticClass: "switcher-container"
    }, [_c('cs-switcher', {
      attrs: {
        "label": _vm.$t('bill.ticket.variant.count.bundle.switcher')
      },
      model: {
        value: tariff.arrangement.isCanCountBundle,
        callback: function callback($$v) {
          _vm.$set(tariff.arrangement, "isCanCountBundle", $$v);
        },
        expression: "tariff.arrangement.isCanCountBundle"
      }
    })], 1), _c('div', {
      staticClass: "grid-two-columns"
    }, [_c('div', {
      staticClass: "input-container"
    }, [tariff.arrangement.isCanCountBundle ? _c('input-number', {
      ref: "countPerPayment",
      refInFor: true,
      attrs: {
        "input-name": _vm.$t('bill.ticket.variant.count.per.payment.label'),
        "input-title": _vm.$t('bill.ticket.variant.count.per.payment.label'),
        "input-placeholder": _vm.$t('bill.ticket.variant.count.per.payment.placeholder'),
        "input-id": "tariff-arrangement-count-per-".concat(idx),
        "show-counter": false,
        "max-length": 3,
        "min-value": 1,
        "max-value": tariff.arrangement.getMaxCountPerPayment(),
        "required": false,
        "only-integer": ""
      },
      model: {
        value: tariff.arrangement.countPerPayment,
        callback: function callback($$v) {
          _vm.$set(tariff.arrangement, "countPerPayment", $$v);
        },
        expression: "tariff.arrangement.countPerPayment"
      }
    }, [_c('help-link', {
      attrs: {
        "slot": "link",
        "source": "https://help.capusta.space/tickets_for_one"
      },
      slot: "link"
    })], 1) : _c('input-number', {
      attrs: {
        "input-name": _vm.$t('bill.ticket.variant.count.bundle.label'),
        "input-title": _vm.$t('bill.ticket.variant.count.bundle.label'),
        "input-placeholder": _vm.$t('bill.ticket.variant.count.bundle.placeholder'),
        "input-id": "tariff-arrangement-count-bundle-".concat(idx),
        "show-counter": false,
        "max-length": 3,
        "min-value": 1,
        "max-value": tariff.arrangement.getMaxCountPerPayment(),
        "only-integer": "",
        "required": ""
      },
      model: {
        value: tariff.arrangement.countBundle,
        callback: function callback($$v) {
          _vm.$set(tariff.arrangement, "countBundle", $$v);
        },
        expression: "tariff.arrangement.countBundle"
      }
    }, [_c('help-link', {
      attrs: {
        "slot": "link",
        "source": "https://help.capusta.space/tickets_for_payment"
      },
      slot: "link"
    })], 1)], 1), _c('div', {
      staticClass: "input-container"
    }, [_c('input-number', {
      attrs: {
        "input-name": _vm.$t('bill.ticket.variant.count.label'),
        "input-title": _vm.$t('bill.ticket.variant.count.label'),
        "input-placeholder": _vm.$t('bill.ticket.variant.count.placeholder'),
        "input-id": "tariff-arrangement-count-".concat(idx),
        "show-counter": false,
        "max-length": 6,
        "min-value": 1,
        "max-value": 10000,
        "required": false,
        "only-integer": ""
      },
      model: {
        value: tariff.arrangement.count,
        callback: function callback($$v) {
          _vm.$set(tariff.arrangement, "count", $$v);
        },
        expression: "tariff.arrangement.count"
      }
    }, [_c('help-link', {
      attrs: {
        "slot": "link",
        "source": "https://help.capusta.space/tickets_on_sale"
      },
      slot: "link"
    })], 1)], 1)])] : [_c('div', {
      staticClass: "input-container"
    }, [_c('input-number', {
      attrs: {
        "input-name": _vm.$t('bill.ticket.variant.count.bundle.label'),
        "input-title": _vm.$t('bill.ticket.variant.count.bundle.label'),
        "input-placeholder": _vm.$t('bill.ticket.variant.count.bundle.placeholder'),
        "input-id": "tariff-arrangement-count-bundle-".concat(idx),
        "show-counter": false,
        "max-length": 3,
        "min-value": 1,
        "max-value": 100,
        "only-integer": "",
        "required": ""
      },
      model: {
        value: tariff.arrangement.countBundle,
        callback: function callback($$v) {
          _vm.$set(tariff.arrangement, "countBundle", $$v);
        },
        expression: "tariff.arrangement.countBundle"
      }
    }, [_c('help-link', {
      attrs: {
        "slot": "link",
        "source": "https://help.capusta.space/tickets_for_payment"
      },
      slot: "link"
    })], 1)], 1)], _c('labeled-input', {
      attrs: {
        "label": _vm.$t('amount.for.pay', {
          getCurrencySign: _vm.currency.sign
        }),
        "placeholder": "0 ".concat(_vm.currency.sign),
        "error": _vm.$v.bill.billTariffs.$each[idx].amount.$error,
        "force-replace": [[/[^0-9\.\,]+/g, ''], [/^\./g, ''], [/\,/, '\.']],
        "force-format": [_vm.$formatInputAmount({
          significantZeros: _vm.currency.significant_zeros,
          decimalsSeparator: '.',
          thousandSeparator: ' '
        })]
      },
      on: {
        "focus": _vm.$v.bill.billTariffs.$each[idx].amount.$reset,
        "blur": _vm.$v.bill.billTariffs.$each[idx].amount.$touch
      },
      model: {
        value: tariff.amount,
        callback: function callback($$v) {
          _vm.$set(tariff, "amount", $$v);
        },
        expression: "tariff.amount"
      }
    }), !_vm.isDesktop ? [_vm.isSeveralTariffsAvailable ? _c('div', {
      staticClass: "controls-container"
    }, [_c('form-movement-control', {
      attrs: {
        "inactive-up": _vm.isInactiveMovementUp(idx),
        "inactive-down": _vm.isInactiveMovementDown(idx)
      },
      on: {
        "movementUp": function movementUp($event) {
          return _vm.onMovementUp(idx);
        },
        "movementDown": function movementDown($event) {
          return _vm.onMovementDown(idx);
        }
      }
    }), _c('form-delete-icon', {
      on: {
        "click": function click($event) {
          return _vm.onRemoveTariff(idx);
        }
      }
    })], 1) : _vm._e()] : _vm._e()], 2)], 2);
  }), !_vm.isExceededTariffsCount ? _c('div', {
    staticClass: "panel-container"
  }, [_c('capusta-panel', {
    attrs: {
      "icon": "circle-plus",
      "description": _vm.$t('add.variant')
    },
    on: {
      "click": _vm.onAddTariff
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('get.link')) + " ")])], 1), _c('div', {
    staticClass: "button-secondary-container"
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmitWithQrCode
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('cs-icon', {
    attrs: {
      "name": "qr-code",
      "size": "extra-medium"
    }
  })], 1), _vm._v(" " + _vm._s(_vm.$t('get.qr')) + " ")])], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }